import { createLucideIcon } from './lucideIcon'

export const Maximize2 = createLucideIcon(
  'Maximize2',
  <>
    <path d="M15 3h6v6" />
    <path d="m21 3-7 7" />
    <path d="m3 21 7-7" />
    <path d="M9 21H3v-6" />
  </>
)
